import HtzImage from './HtzImage';
import { videoToImageProps } from './videoToImageProps';

export * from './HtzImage';

export default HtzImage;
export { videoToImageProps };
